export const GATEWAY_BASE_URL = import.meta.env.VITE_GATEWAY_URL || 'https://api.portal.majormaker.org';

/**
 * Universal fetch wrapper for public_gateway.
 * Automatically attaches the application identifier and current session bearer token.
 */
export async function gatewayFetch(endpoint, options = {}) {
  const token = localStorage.getItem('access_token');
  const headers = {
    'Content-Type': 'application/json',
    'X-App-ID': 'majormaker-quick-bookings',
    ...(token && { 'Authorization': `Bearer ${token}` }),
    ...options.headers
  };

  const response = await fetch(`${GATEWAY_BASE_URL}${endpoint}`, {
    ...options,
    headers
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    let message = errorData.detail;

    if (Array.isArray(message)) {
      message = message.map(e => `${e.loc ? e.loc.join('.') : 'field'}: ${e.msg}`).join(', ');
    } else if (typeof message === 'object') {
      message = JSON.stringify(message);
    }

    throw new Error(message || `Gateway error: ${response.status}`);
  }

  return response.json();
}